import React from 'react'
import PropTypes from 'prop-types'
import { StyledButton } from 'portal-modules/common/components/Button'
import ExternalLink from 'portal-modules/common/components/ExternalLink'

const ExternalButton = StyledButton.withComponent(ExternalLink)

const ButtonAsExternalLink = ({ children, ...rest }) => (
  <ExternalButton {...rest} appearance='action'>
    {children}
  </ExternalButton>
)

ButtonAsExternalLink.propTypes = {
  children: PropTypes.node,
}

export default ButtonAsExternalLink
